import * as React from "react";
import type { SVGProps } from "react";
const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2251_4496)">
      <path
        d="M10.1643 17.6276L21.4468 27.5189C21.5768 27.6335 21.7343 27.7125 21.904 27.7479C22.0736 27.7833 22.2496 27.774 22.4146 27.721C22.5795 27.6679 22.7279 27.5729 22.8451 27.4452C22.9623 27.3175 23.0443 27.1616 23.0831 26.9926L28.1643 4.92138C28.1693 4.89925 28.1681 4.87618 28.161 4.85466C28.1538 4.83313 28.1409 4.81396 28.1237 4.79919C28.1065 4.78441 28.0856 4.77461 28.0633 4.77081C28.0409 4.76701 28.0179 4.76937 27.9968 4.77763L2.66431 14.6914C2.50704 14.7519 2.37366 14.8618 2.28417 15.0046C2.19468 15.1474 2.15392 15.3153 2.16801 15.4833C2.1821 15.6512 2.25027 15.81 2.3623 15.9359C2.47432 16.0618 2.62416 16.1479 2.78931 16.1814L10.1643 17.6276Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1643 17.6277L28.0906 4.78015"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7106 22.4914L11.8843 26.4614C11.7461 26.6049 11.5681 26.7038 11.3733 26.7454C11.1785 26.787 10.9756 26.7695 10.7908 26.6951C10.606 26.6207 10.4476 26.4928 10.336 26.3278C10.2244 26.1628 10.1646 25.9682 10.1643 25.7689V17.6277"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2251_4496">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.164307 0.768921)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTelegram;
